<template>
  <div class="columns fade-in-1s targets-container">

    <!-- Side bar -->
    <div class="column is-3 targets-side-bar">
      <div class="flex-center">
        <span class="targets-back flex-center" style="text-align: center;" @click="goBack()">
          <icon class="tiny-svg fill-gray flex" name="arrow-left"></icon>
          {{$t('targets.backButtonLabel')}}
        </span>
      </div>
      <!-- <div class="column flex-center targets-scenario">
        <span v-if="getScenarios && getScenarios.length > 1">getSelectedScenario.name</span>
      </div> -->
      <!-- <div class="column targets-goal-selected flex-center">
        <icon class="tiny-svg fill-gray flex" name="info"></icon>
        <span class="targets-goal-selected-header">{{$t('targets.wheelInfoText')}}</span> -->
        <!-- <span class="targets-goal-selected-header">{{$t('targets.globalGoalLabel')}}</span> -->
        <!-- <span class="targets-goal-selected-title">{{activeGoal.code}}: {{activeGoal.title}}</span> -->
      <!-- </div> -->
      <div class="column target-wheel-container flex-justify-content-center">
        <div class="target-wheel" style="position: relative;">
          <span class="targets-goal-selected-header" >{{$t('targets.wheelInfoText')}}</span>
          <wheel :selectedGoals="getSelectedGoals" @goalClicked="selectedGoal" :disabledGoals="getUnSelectedGoals" :mode="'target'" :showGoalsImmediately="true" :showIcons="true" :class="[getWheelVisible ? 'opacity-full': 'opacity-none']" ref="targetWheel" :view="currentState" :name="'targets'"></wheel>
        </div>
      </div>
      <div class="column flex-center flex-direction-column" v-if="getActiveGoal.targets"> <!-- results-button-container -->
        <!-- <button class="results-button" @click="goToResults()">{{$t('targets.resultLabel')}}</button> -->
        <span class="targets-goal-selected-header-result">
          <!-- <icon class="tiny-svg fill-gray inline-block vertical-align-small" name="info"></icon> -->
          {{$t('targets.resultHeader')}}
          </span>
        <div class="target-wheel-thumb">
          <wheel-result-thumb :selectedTargetToWheel="selectedTargetToWheel" :view="'results'"></wheel-result-thumb>
          <!-- <wheel-result-thumb :style="{ visibility: targetWheelButtonVisiblity }" :selectedTargetToWheel="selectedTargetToWheel" :view="'results'"></wheel-result-thumb> -->
          <div class="target-wheel-button-div" ref="targetWheelButton">
            <button class="results-button" @click="goToResults()">{{$t('targets.showLabel')}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Targets -->
    <div class="column is-9 targets-content">
      <div class="columns flex-direction-column">

        <!-- Header -->
        <div class="column is-12 target-header">
          <div v-if="getActiveGoal.code">
            <icon class="large-svg sdg-target-icons" :name="getActiveGoal.code" :language="getLanguage"></icon>
            <h1 class="target-color" :class="['goal-color-' + getActiveGoal.code]">{{activeGoal.code}}: {{activeGoal.title}}</h1>
          </div>
          <div>
            <h5 v-if="!getEditMode">{{$t('targets.targetsSubtitle')}}</h5>
            <h5 v-else>{{$t('targets.targetsSubtitleEdit')}}</h5>
            <!-- <div @click="showHelp = true">
              <icon class="tiny-svg fill-primary flex help-icon" name="info"></icon>
              <icon class="medium-svg" style="position: absolute; top: -14px; left: 10px;" name="sdg-wheel-black"></icon>
              <icon class="tiny-svg" style="position: absolute; left: 22px; top: 3px;" name="info-simple"></icon>
            </div>
            <div v-if="showHelp" class="help-content">
              fnsdjfg duigh uifdguifdh guifdh guifh guifd
              gjifd hguifh duigdui
              fsdfsdfsd
              f
              sdgsd
              fsdf
              sd
              fsdgfh
              flagfgh
              fg
              <h1>h
                flagh
              </h1>
            </div> -->
          </div>
        </div>

        <!-- Target list -->
        <div class="column is-12 target-list" ref="targetList">
          <transition-group :name="getEditMode ? '' : 'list'" tag="div">
            <div v-for="(target, index) in getActiveGoal.targets" v-show="!getEditMode ? true : target.selected" :key="target.code" class="columns target-row" @click="!getEditMode && methodSetSelectedTargets(target)">
              <div class="column is-1" style="min-width: 90px;">
                <div>
                  <icon class="large-svg sdg-target-icons" :class="['goal-color-' + getActiveGoal.code, {'goal-selected': getEditMode || (getActiveGoal.targets && getActiveGoal.targets.filter(selectedTarget => selectedTarget.selected && selectedTarget.code === target.code).length > 0)}]" :name="target.displayCode"></icon>
                </div>
              </div>
              <div class="column is-10 target-input" :class="[{'selected': target.selected && !getEditMode, 'selectable': !getEditMode}]">

                <!-- Header -->
                <div class="columns">
                  <div class="column is-1 target-column-space-max semi-bold">
                    {{target.displayCode}}
                  </div>
                  <div class="column" v-html="target.description"></div>
                </div>

                <!-- Read mode -->
                <div class="columns" v-if="!getEditMode && target.action !== null && target.indicator !== null">
                  <div class="column is-1 target-column-space-max"></div>
                  <div class="column is-4 target-input-label">
                    <div class="flex-align-center">
                      <icon class="small-svg fill-primary" name="actions"></icon>
                      <span v-if="target.action === '' || target.action === null">{{$t('targets.actionSummaryLabelNon')}}</span>
                      <span class="truncate-target-input" v-else>{{target.action}}</span>
                    </div>
                  </div>
                  <div class="column is-4 target-input-label">
                    <div class="flex-align-center">
                      <icon class="small-svg fill-primary" name="flag"></icon>
                      <span v-if="target.indicator === '' || target.indicator === null">{{$t('targets.indicatorSummaryLabelNon')}}</span>
                      <span class="truncate-target-input" v-else>{{target.indicator}}</span>
                    </div>
                  </div>
                  <div class="column is-3 target-input-label flex-align-center">
                    <div class="flex-align-center">
                      <icon class="medium-flat-svg fill-primary flex-center" :name="'effect' + target.effect"></icon>
                      <span>{{translateSlider(target.effect)}}</span>
                    </div>
                  </div>
                </div>

                <!-- Write mode -->
                <!-- v-if is used here because of the slider -->
                <div class="columns" v-if="getEditMode">
                  <div class="column is-1 target-column-space-max"></div>
                  <div class="column">
                    <div class="field">
                      <div class="flex-align-center target-input-label write-mode">
                        <icon class="small-svg fill-primary" name="actions"></icon>
                        <label>{{$t('targets.actionLabel')}}</label>
                      </div>
                      <div class="control">
                        <textarea class="textarea" rows="6" v-model="target.action" @blur="methodSetSelectedTargets(target)" :placeholder="[[$t('targets.actionPlaceholder')]]"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <div class="flex-align-center target-input-label write-mode">
                        <icon class="small-svg fill-primary" name="flag"></icon>
                        <label>{{$t('targets.indicatorLabel')}}</label>
                        <!-- <div class="flex-justify-content-center UN-indicator-button">
                          <icon class="small-svg flex-center" name="un"></icon>
                        </div> -->
                      </div>
                      <div class="control">
                        <textarea class="textarea" rows="6" v-model="target.indicator" @blur="methodSetSelectedTargets(target)" :placeholder="[[$t('targets.IndicatorPlaceholder')]]"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="column is-4">
                    <div class="flex-align-center target-input-label write-mode">
                      <icon class="medium-svg fill-primary flex-center" name="effect0"></icon>
                      <label>{{$t('targets.effectLabel')}}</label>
                    </div>
                    <div class="columns">
                      <div class="column">
                        {{$t("targets.targetEffectNegative")}}
                      </div>
                      <div class="column flex-align-center slider-center">
                        {{$t("targets.targetEffectNone")}}
                      </div>
                      <div class="column flex-justify-content-end">
                        {{$t("targets.targetEffectPositive")}}
                      </div>
                    </div>
                    <vue-slider ref="slider" :piecewise="true" :dotSize="20" :tooltip="false" :min="-2" :max="3" v-model="target.effect" @callback="methodSetSelectedTargets(target)"></vue-slider>
                  </div>
                </div>
                <div class="columns" v-if="getEditMode && getActiveGoal.targets.filter(target => target.selected).length > 1 && index !== (getActiveGoal.targets.filter(target => target.selected).length - 1)">
                  <div class="column is-12 target-row-bottom-border"></div>
                </div>
              </div>
            </div>
          </transition-group>
        </div>

        <!-- Selected targets -->
        <div class="column is-12 flex-center selected-targets-container" v-if="getActiveGoal.targets && getActiveGoal.targets.filter(selectedTargets => selectedTargets.selected).length > 0">
          <button v-if="!getEditMode" class="targets-button selected-targets-button" :class="{'bounceIn': !getEditMode}" @click="setEditMode(true), setScroll()">
            <!-- <icon class="small-svg fill-white flex-center" name="equalizer"></icon> -->
            {{$t('targets.selectedTargetsButton')}}
          </button>
          <button v-else class="targets-button all-targets-button" @click="setEditMode(false), setScroll()">
            {{$t('targets.allTargetsButton')}}
          </button>
          <div class="selected-targets-counter">
            <span>
              {{getActiveGoal.targets.filter(target => target.selected).length}}
            </span>
            <span>
              {{$t('targets.targetLabel')}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import wheel from './../shared/sdg-wheel/sdg-wheel.vue'
import vueSlider from 'vue-slider-component'
import wheelResultThumb from './../shared/sdg-wheel/sdg-wheel-result-thumb.vue'

export default {
  name: 'targets',
  components: {
    wheel,
    vueSlider,
    'wheel-result-thumb': wheelResultThumb
  },
  props: {
    currentState: {
      type: String
    }
  },
  data () {
    return {
      showHelp: false,
      scenario: { name: null },
      activeGoal: {
        code: null,
        title: null
      },
      selectedTargets: [],
      // SKAL FIXES test
      selectedTargetToWheel: null
      // targetWheelButtonVisiblity: 'visible'
    }
  },
  computed: {
    ...mapGetters({
      getEditMode: 'getEditMode',
      getWheelVisible: 'getWheelVisible',
      getProject: 'getProject',
      getSelectedScenario: 'getSelectedScenario',
      getSelectedGoals: 'getSelectedGoals',
      getUnSelectedGoals: 'getUnSelectedGoals',
      getGoalList: 'getGoalList',
      getTargetList: 'getTargetList',
      getActiveGoal: 'getActiveGoal',
      getLanguage: 'getLanguage'
    })
  },
  watch: {
    currentState (val, oldVal) {
      if (val === 'targets') {
        this.$nextTick(() => {
          this.$emit('goTo2')
          // this.handleResize()
        })
      }
    },
    getActiveGoal (val, oldVal) {
      if (val.code !== oldVal.code) {
        for (let i = 0, n = this.getGoalList.length; i < n; i++) {
          if (Number(this.getGoalList[i].code) === val.code) {
            this.activeGoal.code = this.getGoalList[i].code
            this.activeGoal.title = this.getGoalList[i].title
            break
          }
        }
      }
    }
  },
  methods: {
    ...mapActions({
      setTargetWheel: 'setTargetWheel',
      setSelectedTargets: 'setSelectedTargets',
      setTargetList: 'setTargetList',
      setEditMode: 'setEditMode',
      setEmptyProjectInput: 'setEmptyProjectInput',
      setActiveGoal: 'setActiveGoal'
    }),
    translateSlider (effect) {
      let effectLabel = null
      switch (effect) {
        case -2:
          effectLabel = this.$t('targets.targetEffect-2')
          break
        case -1:
          effectLabel = this.$t('targets.targetEffect-1')
          break
        default:
        case 0:
          effectLabel = this.$t('targets.targetEffect0')
          break
        case 1:
          effectLabel = this.$t('targets.targetEffect1')
          break
        case 2:
          effectLabel = this.$t('targets.targetEffect2')
          break
        case 3:
          effectLabel = this.$t('targets.targetEffect3')
          break
      }
      return effectLabel
    },
    async selectedGoal (goal) {
      try {
        await this.setEmptyProjectInput()
        this.setScroll()
        this.setActiveGoal(goal)
      } catch (err) {
        throw new Error(err)
      }
    },
    setScroll () {
      this.$nextTick(() => {
        this.$refs.targetList.scrollTop = 0
      })
    },
    async goToResults () {
      try {
        await this.setEmptyProjectInput()
        this.$emit('goTo', 'results')
      } catch (err) {
        throw new Error(err)
      }
    },
    async goBack () {
      try {
        await this.setEmptyProjectInput()
        this.$emit('goTo', 'goals')
      } catch (err) {
        throw new Error(err)
      }
    },
    methodSetSelectedTargets (target) {
      this.setSelectedTargets(target)
      this.selectedTargetToWheel = new Date()
    }
    // handleResize (e) {
    //   if (this.currentState === 'targets' && this.$refs.targetWheelButton) {
    //     const bounding = this.$refs.targetWheelButton.getBoundingClientRect()

    //     if (
    //       bounding.top >= 0 &&
    //       bounding.left >= 0 &&
    //       window.innerWidth >= 800 &&
    //       window.innerHeight >= 950
    //     ) {
    //       this.targetWheelButtonVisiblity = 'visible'
    //     } else {
    //       // this.targetWheelButtonVisiblity = 'hidden'
    //     }
    //   }
    // }
  }
  // created () {
  //   window.addEventListener('resize', this.handleResize)
  // },
  // destroyed () {
  //   window.removeEventListener('resize', this.handleResize)
  // }
}
</script>
